import { useEffect, useState } from "react";
import { useAppSelector } from "@litres-core/store";

const RESTRICTED_PAGES = [
  "/my-books/",
  "/my_books_all/",
  "/my_books_fresh/",
  "/my_views/",
  "/my_settings/",
  "/by_subscription/",
  "/new_liked/",
  "/new_basket/",
  "/my_folders_list/",
  "/personal_cabinet",
  "/put_money_on_account/",
  "/promocode/",
  "/abonement-v-podarok/",
  "/abonement/",
  "/litres_subscription/",
  "/reader/",
  "/selfpub/",
  "/selfpublishing/",
  "/drafts/",
  "/app/",
  "/company-menu/",
  "/ux-research-now/",
  "/become-an-author/",
  "/subscription/",
  "/journal/",
  // продовая версия страницы Информация для входа ЛК
  "/me/credentials/",
  "/me/",
  "/otzyv/",
  "/promocode/",
  "/pages/receipt/",
  "/pages/2024-year-in-review/",
  "/pages/2024-year-in-review/share/",
];

const isAllowedPageForToggleBanner = (): boolean => {
  const pathname = window.location.pathname;
  const isBookPage =
    // @ts-ignore
    !!window.litres?.book?.id ||
    !!document.getElementById("book-card__wrapper");
  return (
    !isBookPage &&
    (pathname === "/" ||
      !RESTRICTED_PAGES.some(page => {
        return pathname.includes(page);
      }))
  );
};

interface IUseShouldShowToggleBannnerProps {
  isSchoolDomain: boolean;
  isLibraryDomain: boolean;
  isForeignDomain: boolean;
  isSubscriptionDomain: boolean;
  isMobileOperatorDomain: boolean;
}

export const useShouldShowToggleBannner = ({
  isSchoolDomain,
  isLibraryDomain,
  isForeignDomain,
}: IUseShouldShowToggleBannnerProps): boolean => {
  const [isToggleBannerVisible, setToggleBannerVisible] = useState(false);
  const { partner_subscriptions } = useAppSelector(
    state => state.foundationUser
  );

  // не показываем свитчер на школьном/библио/uz/az/tr доменах
  const isAllowedDomain = !(
    isSchoolDomain ||
    isLibraryDomain ||
    isForeignDomain
  );

  // [NAV-2522] - для отображении тоггла учитываем только активную партнерскую подписку (подписку литреса не учитываем)
  useEffect(() => {
    const isAllowedPage = isAllowedPageForToggleBanner();
    setToggleBannerVisible(
      isAllowedPage && isAllowedDomain && partner_subscriptions.has_active
    );
  }, []);
  return isToggleBannerVisible;
};
